// src/components/ScrollProgressBar.js
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollProgressBar() {
  const { pathname } = useLocation();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const percent = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
      setProgress(percent);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [pathname]);

  if (pathname === "/contact") {
    return null;
  }

  return (
    <div
      className="fixed top-0 left-0 w-full z-50"
      style={{ height: "4px", backgroundColor: "#000000" }}
    >
      <div
        className="h-full"
        style={{ width: `${progress}%`, backgroundColor: "#960000" }}
      />
    </div>
  );
}
